import { setSubroute } from 'store/navbar'
import DataCorrectionV2PageRoute from './routes/DataCorrectionV2Page'
import CreateDCFRoute from './routes/CreateDCF'

export default store => ({
  path: 'data-correction-v2',
  indexRoute: DataCorrectionV2PageRoute(store),
  getChildRoutes(location, cb) {
    store.dispatch(setSubroute('dataCorrectionV2'))
    cb(null, [CreateDCFRoute(store)])
  },
})
